module.exports = __webpack_public_path__ + "img/img25.449ac03a.svg";